import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { InventoryEntities } from 'client/data/models/inventory';
import { getDealerFeesLinkText } from 'site-modules/shared/utils/inventory/srp-card-utils';
import { isPrivateParty } from 'site-modules/shared/utils/dealer-details-utils';
import { isNew } from 'site-modules/shared/utils/inventory-utils/is-new';
import { DealerFeesLinkModal } from 'site-modules/shared/components/inventory/dealer-fees-modal/dealer-fees-link-modal';
import { useToggle } from 'site-modules/shared/hooks/use-toggle';

export const DealerFeesLink = memo(({ vehicle, isLeaseOrLoan = false }) => {
  const [isOpen, toggle] = useToggle(false);

  const linkText = getDealerFeesLinkText(vehicle);

  const { year, make, model } = vehicle?.vehicleInfo?.styleInfo ?? {};
  const vehicleLabel = [year, make, model].filter(Boolean).join(' ');
  const ariaLabel = vehicleLabel ? `${linkText} for ${vehicleLabel}` : linkText;

  if (!linkText || isPrivateParty(vehicle) || isLeaseOrLoan) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        aria-label={ariaLabel}
        aria-haspopup="dialog"
        className={classNames('btn btn-link p-0 text-dark text-decoration-underline fw-normal text-end', {
          'size-14': isNew(vehicle.type),
          'size-12': !isNew(vehicle.type),
        })}
        style={{
          textTransform: 'none',
          paddingBottom: '0.5rem',
          ...(isNew(vehicle.type) ? { paddingBottom: '0.25rem' } : {}),
        }}
        onClick={toggle}
        data-tracking-id="srp_dealer_fees_button_click"
        data-tracking-value={linkText}
      >
        {linkText}
      </button>
      {isOpen && <DealerFeesLinkModal vin={vehicle.vin} isOpen={isOpen} toggle={toggle} />}
    </>
  );
});

DealerFeesLink.displayName = 'DealerFeesModalSrp';

DealerFeesLink.propTypes = {
  vehicle: InventoryEntities.InventoryVin.isRequired,
  isLeaseOrLoan: PropTypes.bool,
};
